/* =============================================================================
   T3BLOGG_OS — assets/product.js
   Variant picker — no page reload. Reads variants from <script id="product-data">.
   ============================================================================= */

(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const moneyFmt = cents => window.T3Money(cents);

  function init() {
    const form = $('form[data-product-form]');
    if (!form) return;
    const dataEl = form.querySelector('[data-product-json]') || $('#product-data');
    if (!dataEl) return;
    let product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // .sizes and .price-row live in .info, OUTSIDE the <form> — query from the
    // product detail root, not the form, or these come back null.
    const root = form.closest('.pd') || document;
    const sizesEl = root.querySelector('.sizes');
    const priceEl = root.querySelector('.price-row [data-price]');
    const compareEl = root.querySelector('.price-row [data-compare]');
    const idInput = form.querySelector('input[name="id"]');
    const btn = form.querySelector('.btn-add');
    const qtyEl = form.querySelector('input[name="quantity"]');
    const decBtn = form.querySelector('.qty .dec');
    const incBtn = form.querySelector('.qty .inc');

    let selectedVariant = product.variants.find(v => v.available) || product.variants[0];

    // Use whatever the first multi-value option is (Size, Color, etc).
    let pickerIdx = -1;
    for (let i = 0; i < (product.options || []).length; i++) {
      const seen = new Set();
      product.variants.forEach(v => seen.add(v.options[i]));
      if (seen.size > 1) { pickerIdx = i; break; }
    }

    function findVariantBySize(value) {
      if (pickerIdx < 0) return null;
      return product.variants.find(v => v.options[pickerIdx] === value);
    }

    function paint() {
      if (idInput && selectedVariant) idInput.value = selectedVariant.id;
      if (priceEl && selectedVariant) priceEl.textContent = moneyFmt(selectedVariant.price);
      if (compareEl && selectedVariant) {
        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          compareEl.textContent = moneyFmt(selectedVariant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (btn && selectedVariant) {
        btn.disabled = !selectedVariant.available;
        btn.innerHTML = selectedVariant.available ? '&gt;&gt; ADD TO CART' : '// SOLD_OUT';
      }
    }

    if (sizesEl) {
      sizesEl.addEventListener('click', e => {
        const pill = e.target.closest('.size-pill');
        if (!pill || pill.disabled) return;
        sizesEl.querySelectorAll('.size-pill').forEach(p => p.setAttribute('aria-pressed', 'false'));
        pill.setAttribute('aria-pressed', 'true');
        const variant = findVariantBySize(pill.dataset.size);
        if (variant) {
          selectedVariant = variant;
          paint();
        }
      });
    }

    if (decBtn) decBtn.addEventListener('click', e => {
      e.preventDefault();
      qtyEl.value = Math.max(1, parseInt(qtyEl.value || 1, 10) - 1);
    });
    if (incBtn) incBtn.addEventListener('click', e => {
      e.preventDefault();
      qtyEl.value = Math.min(99, parseInt(qtyEl.value || 1, 10) + 1);
    });

    paint();

    // Thumbnail strip: click → scroll main media to that image. Scroll → update active thumb via IntersectionObserver.
    const scroller = document.querySelector('[data-media-scroll]');
    const thumbs   = document.querySelectorAll('[data-media-thumbs] button');
    const scrollImgs = scroller ? scroller.querySelectorAll('img[data-idx]') : [];

    if (thumbs.length && scroller) {
      thumbs.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.dataset.idx, 10);
          const target = scrollImgs[idx];
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
              const idx = parseInt(entry.target.dataset.idx, 10);
              thumbs.forEach(b => b.classList.toggle('active', parseInt(b.dataset.idx, 10) === idx));
            }
          });
        }, { root: scroller, threshold: [0.5] });
        scrollImgs.forEach(img => io.observe(img));
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
